import script from "./EntityDatumRow.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityDatumRow.vue?vue&type=script&setup=true&lang=js"

import "./EntityDatumRow.vue?vue&type=style&index=0&id=7f8c0682&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8c0682"]])

export default __exports__